import React, { Component } from 'react';
import './button.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import { layer } from '@fortawesome/fontawesome-svg-core';



class Button extends Component {
    constructor(props) {
      super(props);
      // PROPS
      /* 
      --config = {icon:"",text:"",color:"",textAlign:"",bgcolor:"",isEnabled:true}
          //icon:
          //text:
          //color:
          //textAlign:
          //bgcolor:
          //isEnabled:

       --preventMultipleClick //delay in ms before being able to click again
       --OnClickElement

      */ 
      // State is in reducers
        this.state = {
          pendingRequest:false //display spinner if you want to prevent multiple clicks
        };

        this.timer = null;

  }

  // INNER METHOD
  onClickUpdate = () =>{
    if(this.props.config.isEnabled){
      if(this.props.preventMultipleClick !== null && this.props.preventMultipleClick >=0){
        this.setState({pendingRequest:true});
        this.props.OnClickElement();
        // waiting as defined
        this.timer = setTimeout(
          function() {
            this.setState({pendingRequest:false});
          }
          .bind(this),
          this.props.preventMultipleClick
        );
      }else{
        this.props.OnClickElement()
      }
    }
    
  }

  // BUILDING METHOD
  componentWillUnmount = () =>{
    clearTimeout(this.timer);
  }


  // ---------------------RENDER --------------------- 
  render() {
    var labelStyle = {background:this.props.config.bgcolor, color: this.props.config.color,textAlign:this.props.config.textAlign};


    return (
          <div className={"button enabled-"+this.props.config.isEnabled} style={labelStyle} onClick={this.onClickUpdate.bind()}>
              <FontAwesomeIcon icon={this.props.config.icon !== null?this.props.config.icon:""}/>
              <span className="text">{this.props.config.text}</span>
              <div className={this.state.pendingRequest?"loader show":"loader hide"}><FontAwesomeIcon icon="spinner"/></div>
          </div>
    );
  }
}
  
const mapStateToProps = (state) => {    
  return {  
    
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(Button);
  